// extracted by mini-css-extract-plugin
module.exports =  {"jobCard":"Jobs-module_jobCard_a15f8"};